import styled from 'styled-components';
import { blue, grey, hoverBlue, lightGray, lightGrayThird } from '../../assets/ui/colors';

export const BodyContainer = styled.div`
    background: white;
    border: 1px solid ${lightGrayThird};
    border-radius: 6px;
`;

export const MobileCard = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid ${lightGray};
    border-radius: 4px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.24);
    margin-bottom: 16px;
    padding: 12px;
    position: relative;
    cursor: pointer;
`;

export const MobileCardTitle = styled.div`
    font-weight: 600;
    margin-right: 30px;
`;

export const MobileCardDate = styled.div`
    color: ${grey};
    margin: 8px 0;
`;

export const MobileCardFormat = styled.div`
    position: absolute;
    top: calc(50% - 10px);
    right: 12px;
    color: ${grey};
`;

export const FiltersContainer = styled.div`
    display: flex;
    align-items: center;
    position: absolute;
    right: 24px;
    top: 82px;
    & svg {
        margin-left: 27px;
    }
    @media (max-width: 600px) {
        position: inherit;
        flex-wrap: wrap;
        margin-bottom: 24px;
    }
`;

export const FilterItem = styled.div`
    border-radius: 16px;
    margin: 5px;
    padding: 6px 20px;
    background: ${props => props.isActive ? hoverBlue : lightGray};
    color: ${props => props.isActive ? 'white': 'auto'};
    cursor: pointer;
    transition: 0.3s;
    :hover {
        background: ${props => props.isActive ? blue : hoverBlue};
        color: white;
    }
`;
